import Odometer from './Odometer';

export default Odometer;
